module.exports = __webpack_public_path__ + "img/box9-05.6465a790.png";